import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Button, Typography } from '@mui/material';
import RegisterForm from '../forms/registration.form';
import LoginForm from '../forms/login.form';

interface AuthFormModalProps {
  open: boolean;
  onClose: () => void;
  onDone: () => void;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

const AuthFormModal: React.FC<AuthFormModalProps> = ({ open, onDone, onClose, size = 'md' }) => {
  const [showRegistrationFormModal, setShowRegistrationFormModal] = useState(false);
  const [showLoginFormModal, setShowLoginFormModal] = useState(true);

  const openRegistrationFormModal = () => {
    setShowLoginFormModal(false);
    setShowRegistrationFormModal(true);
  };

  const openLoginFormModal = () => {
    setShowRegistrationFormModal(false);
    setShowLoginFormModal(true);
  };

  const onRegistrationSuccess = () => {
    setShowRegistrationFormModal(false);
    onDone();
  };

  const onLoginSuccess = () => {
    setShowLoginFormModal(false);
    onDone();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth={size} fullWidth>
      <DialogContent>
        {showRegistrationFormModal && (
          <RegisterForm onSuccess={onRegistrationSuccess} loginCallback={openLoginFormModal} />
        )}
        {showLoginFormModal && (
          <LoginForm onSuccess={onLoginSuccess} registerCallback={openRegistrationFormModal} />
        )}
        {/* ✅ Close Link at Bottom */}
        <Typography align="center" sx={{ mt: 2 }}>
          <Button onClick={onClose} variant="text">
            Close
          </Button>
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default AuthFormModal;
